<template>
    <v-dialog :model-value="modelValue" max-width="440" @update:model-value="$emit('update:modelValue', $event)">
        <v-card rounded="lg">
            <v-card-title class="text-h6 pt-4 px-5">{{ copy.title }}</v-card-title>
            <v-card-text class="px-5 text-body-2 text-medium-emphasis">
                <p>{{ copy.text }}</p>
                <p v-if="ignoredFilters" class="mt-2">
                    The {{ ignoredFilters }} {{ ignoredFilters.includes(' and ') ? 'filters are' : 'filter is' }}
                    not applied to this.
                </p>
            </v-card-text>
            <v-card-actions class="px-5 pb-4">
                <v-spacer/>
                <v-btn variant="text" :disabled="loading" @click="$emit('update:modelValue', false)">Cancel</v-btn>
                <v-btn :color="action === 'clear' ? 'error' : 'primary'" variant="flat"
                       :loading="loading" :disabled="loading" @click="$emit('confirm')">
                    {{ copy.button }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
    modelValue: {type: Boolean, default: false},
    // 'read' marks the viewer's alerts read, 'clear' deletes them
    action: {type: String, default: 'read'},
    loading: {type: Boolean, default: false},
    // The vehicle filter the call is limited to, if any
    vehicleName: {type: String, default: null},
    // Active filters the API cannot apply, e.g. "alert type and date"
    ignoredFilters: {type: String, default: null},
});
defineEmits(['update:modelValue', 'confirm']);

const copy = computed(() => {
    const scope = props.vehicleName ? `all your alerts for ${props.vehicleName}` : 'all your alerts';
    if (props.action === 'clear') {
        return {
            title: 'Clear alerts?',
            text: `This deletes ${scope}. Alerts sent to other people are not affected. This cannot be undone.`,
            button: 'Clear',
        };
    }
    return {
        title: 'Mark alerts read?',
        text: `This marks ${scope} as read.`,
        button: 'Mark read',
    };
});
</script>
